import * as React from "react";

import { CopyToClipboard } from "react-copy-to-clipboard";
import * as Tooltip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap.css";

interface CopyAsCurlProps {
	method: string;
	url: string;
	body: string;
	icon: any;
	headers: HttpHeadersDict;
}

class CopyAsCurl extends React.Component<CopyAsCurlProps, any> {
	state = {
		copied: false,
	};

	timeout = null;

	copyText() {
		clearTimeout(this.timeout);
		this.setState({ copied: true });
		this.timeout = setTimeout(() => this.setState({ copied: false }), 3000);
	}

	render() {
		const hasData = this.props.body.length > 0;

		// method and url
		let value: string = `curl -X ${this.props.method} "${this.props.url}"`;

		value += " \\\n";

		// headers
		for (let i = 0; i < Object.keys(this.props.headers).length; i++) {
			const headerName: string = Object.keys(this.props.headers)[i];
			const headerValue: string = this.props.headers[headerName];

			value += `  -H "${headerName}: ${headerValue}"${
				i < Object.keys(this.props.headers).length - 1 ? "" : " \\\n"
			}`;
		}

		// todo: GET requests

		// request body
		if (hasData) {
			try {
				value += '  -d "' + JSON.stringify(JSON.parse(this.props.body)).replace(/\"/g, '\\"') + '"';
			} catch (e) {
				// todo: this shouldn't ever be the case... the component shouldn't let you copy if the data cannot be stringified
			}
		}

		return (
			<Tooltip
				placement="bottomRight"
				overlay={<span>{this.state.copied ? "Copied cURL command" : "Copy cURL command"}</span>}
			>
				<CopyToClipboard text={value} onCopy={this.copyText.bind(this)}>
					{this.props.icon}
				</CopyToClipboard>
			</Tooltip>
		);
	}
}

export default CopyAsCurl;



// WEBPACK FOOTER //
// ./src/components/CopyAsCurl.tsx